import { render, staticRenderFns } from "./ViewAdvisorHome.vue?vue&type=template&id=1cbc4890&scoped=true&"
import script from "./ViewAdvisorHome.vue?vue&type=script&lang=js&"
export * from "./ViewAdvisorHome.vue?vue&type=script&lang=js&"
import style0 from "./ViewAdvisorHome.vue?vue&type=style&index=0&id=1cbc4890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc4890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VFlex,VLayout,VProgressLinear})
